import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Moment from 'react-moment';
import Button from '@components/Button';
import TextField from '@components/TextField';
import AdminConfig from '@config/admin';
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import { display, visibility } from '@material-ui/system';
import { apiClient } from '@services/api';
import { dateLocale, slugfy, translator } from '@utils/helpers';
import NumberFormat from 'react-number-format';
import Modal from '@components/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import calendar from '@assets/images/icons/calendar.png';
import clock from '@assets/images/icons/clock.png';
import person from '@assets/images/icons/person.png';
import '@css/Admin/index.scss';
import {
  Link,
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams, useRouteMatch
} from "react-router-dom";
import ReactToPrint from 'react-to-print';
import Header from './partials/Header';
import Checkbox from '@components/Checkbox';

const formatDate =(date)=>{
  if(date){
    const newDate = new Date(date)
    return `${newDate.toJSON().split('T')[0].split('-')[2]}/${newDate.toJSON().split('T')[0].split('-')[1]}/${newDate.toJSON().split('T')[0].split('-')[0]}`
  }
}
class Content extends React.Component {
  render() {
    const props = this.props;
    if (!props.voucher || !props.voucher.customerData) return null;
    const idiom = (props.voucher.customerData.language || 'pt').toUpperCase();
    const payment_status = {
      accomplished: { label: 'Pago',     color: '#22c55e' },
      pending:      { label: 'Pendente', color: '#f59e0b' },
      partial:      { label: 'Parcial',  color: '#38bdf8' },
    };

    const language = {
      pt: 'Português',
      en: 'Inglês',
      es: 'Espanhol'
    };

    let lastPaymentId = 0;
    props.voucher.payments.forEach(p => { if (p.id > lastPaymentId) lastPaymentId = p.id; });
    const lastPayment = props.voucher.payments.find(p => p.id === lastPaymentId);
    const paidTotal = props.voucher.payments.reduce((acc, p) => acc + Number(p.total), 0);
    const payStatus = payment_status[lastPayment?.current_status] || { label: lastPayment?.current_status || '—', color: '#64748b' };

    const formatHour = time => {
      if (time) {
        const parts = time.split(':');
        const hour = new Date().setHours(parts[0], parts[1]);
        return format(hour, 'HH:mm');
      }
      return null;
    };

    const calcAdultsValue = (v) => {
      const val = Number(v?.adults_total_amount);
      const qty = Number(v?.adults_total);
      return qty > 1 ? val / qty : val;
    };

    const calcKidsValue = (v) => {
      const val = Number(v?.kids_total_amount);
      const qty = Number(v?.kids_total);
      return qty > 1 ? val / qty : val;
    };

    const cleanText = (text) => {
      if (!text) return '';
      return text
        .replace(/color\s*:\s*[^;}"']+;?/gi, '')
        .replace(/width\s*:\s*\d+px/gi, 'max-width:100%')
        .replace(/\s+width=["']\d+["']/gi, '')
        .replace(/<table/gi, '<table style="width:100%;max-width:100%;table-layout:fixed;word-break:break-word;"')
        .replace(/<img/gi, '<img style="max-width:100%;height:auto;"');
    };

    const getTimes = (v) => {
      if (v.travel.tour_period === 'fullday') return 'Integral';
      if (!v.times || v.times === 'null') return '-';
      return v.times;
    };

    // ── Estilos inline ──────────────────────────────────────────────────────────
    const s = {
      wrap:       { fontFamily: "'Poppins', Arial, sans-serif", background: '#f0f4f8', padding: '0 0 40px' },
      inner:      { maxWidth: '1400px', margin: '0 auto', padding: '0 24px' },
      // Cabeçalho
      hdr:        { background: '#172B4D', padding: '28px 24px', textAlign: 'center' },
      hdrLogo:    { height: '52px', display: 'block', margin: '0 auto 10px' },
      hdrName:    { color: '#e8f0fb', fontSize: '18px', fontWeight: 700, margin: 0 },
      hdrSub:     { color: '#8ba5c4', fontSize: '12px', margin: '4px 0 0' },
      teal:       { background: '#11A1A7', height: '3px' },
      // Cards
      card:       { background: '#fff', borderRadius: '10px', border: '1px solid #e0e7ef', marginTop: '16px', overflow: 'hidden' },
      cardTitle:  { background: '#f8fafc', padding: '12px 18px', fontSize: '13px', fontWeight: 700, color: '#172B4D', borderBottom: '1px solid #e0e7ef', textTransform: 'uppercase', letterSpacing: '0.5px' },
      row:        { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 18px', borderBottom: '1px solid #f1f5f9', gap: '12px' },
      rowLast:    { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 18px', gap: '12px' },
      rowLabel:   { fontSize: '13px', color: '#555', fontWeight: 600, flex: '0 0 auto', maxWidth: '50%' },
      rowValue:   { fontSize: '13px', color: '#172B4D', textAlign: 'right', wordBreak: 'break-word' },
      // Passeio
      tourCard:   { background: '#fff', borderRadius: '10px', border: '1px solid #e0e7ef', borderLeft: '4px solid #11A1A7', marginTop: '12px', overflow: 'hidden' },
      tourName:   { padding: '12px 18px', fontSize: '14px', fontWeight: 700, color: '#172B4D', borderBottom: '1px solid #e0e7ef' },
      // Badge status
      badge:      (color) => ({ display: 'inline-block', background: color + '22', color, border: `1px solid ${color}`, borderRadius: '20px', padding: '2px 12px', fontSize: '12px', fontWeight: 700 }),
      // Termos
      termsWrap:  { background: '#fff', borderRadius: '10px', border: '1px solid #e0e7ef', marginTop: '16px', padding: '18px' },
      termsText:  { fontSize: '12px', color: '#555', lineHeight: '1.7', wordBreak: 'break-word', overflowX: 'hidden' },
      // Assinatura
      signBox:    { background: '#fff', borderRadius: '10px', border: '1px solid #e0e7ef', marginTop: '16px', padding: '20px 18px' },
      signHash:   { background: '#f0f4f8', borderRadius: '6px', padding: '10px 12px', fontSize: '10px', wordBreak: 'break-all', fontFamily: 'monospace', color: '#172B4D', marginTop: '10px' },
      // Rodapé
      footer:     { textAlign: 'center', marginTop: '24px', fontSize: '11px', color: '#8ba5c4' },
    };
    // ── Novo layout responsivo (dark, single-column) ────────────────────────────
    return <div style={s.wrap}>

      {/* ── Cabeçalho empresa ── */}
      <div style={s.hdr}>
        {props.voucher.company.logo
          ? <img src={`${process.env.REACT_APP_BASE_IMAGE_URL}/${props.voucher.company.logo}`} alt={props.voucher.company.name} style={s.hdrLogo} />
          : <p style={s.hdrName}>{props.voucher.company.name}</p>
        }
        <p style={s.hdrName}>{props.voucher.company.name}</p>
        <p style={s.hdrSub}>{translator(idiom, 'voucher', 'rut')}: {props.voucher.company.rut} · Tel: {props.voucher.company.phone}</p>
        <p style={{ ...s.hdrSub, marginTop: '2px' }}>{props.voucher.company.address} · {props.voucher.company.district} · {props.voucher.company.state}</p>
      </div>
      <div style={s.teal} />

      <div style={s.inner}>

        {/* ── Dados do cliente ── */}
        <div style={s.card}>
          <div style={s.cardTitle}>{translator(idiom, 'voucher', 'customers_data')}</div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'customer_name')}</span><span style={s.rowValue}>{props.voucher.reservationData.customer_name}</span></div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'phone')}</span><span style={s.rowValue}>{props.voucher.reservationData.customer_telephone}</span></div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'email')}</span><span style={s.rowValue}>{props.voucher.customerData.email}</span></div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'document')}</span><span style={s.rowValue}>{props.voucher.customerData.document}</span></div>
          {/* Hospedagem por região */}
          {(() => {
            const reservations = props.voucher.reservations;
            if (reservations && reservations.length > 0) {
              // Group by region, keeping the first occurrence of each unique region
              const seen = new Map();
              reservations.forEach(r => {
                const region = r.travel?.region_name || r.travel?.region || (typeof r.tour_region === 'string' ? r.tour_region : null) || 'Geral';
                if (!seen.has(region)) {
                  seen.set(region, {
                    hotel: r.hotel_name || r.hotel || '',
                    address: r.address_hotel || '',
                    room: r.room_number || null,
                  });
                }
              });
              return Array.from(seen.entries()).map(([region, info], i) => {
                const hotelLine = [info.hotel, info.address].filter(Boolean).join(' — ');
                const roomSuffix = info.room ? `, Quarto: ${info.room}` : '';
                const valueText = `${hotelLine}${roomSuffix}`;
                const isLast = i === seen.size - 1;
                return valueText ? (
                  <div key={region} style={isLast ? s.rowLast : s.row}>
                    <span style={s.rowLabel}>Hospedagem {region}</span>
                    <span style={s.rowValue}>{valueText}</span>
                  </div>
                ) : null;
              });
            }
            // Fallback: use reservationData fields
            const fallbackHotel = props.voucher.reservationData?.hotel_name || props.voucher.reservationData?.hotel || '';
            const fallbackAddress = props.voucher.reservationData?.address_hotel || '';
            const fallbackRoom = props.voucher.reservationData?.room_number || null;
            const fallbackLine = [fallbackHotel, fallbackAddress].filter(Boolean).join(' — ');
            const fallbackRoomSuffix = fallbackRoom ? `, Quarto: ${fallbackRoom}` : '';
            const fallbackValue = `${fallbackLine}${fallbackRoomSuffix}`;
            return fallbackValue ? (
              <div style={s.rowLast}>
                <span style={s.rowLabel}>Hospedagem</span>
                <span style={s.rowValue}>{fallbackValue}</span>
              </div>
            ) : null;
          })()}
        </div>

        {/* ── Informações de pagamento ── */}
        <div style={s.card}>
          <div style={s.cardTitle}>{translator(idiom, 'voucher', 'payment_about')}</div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'references')}</span><span style={s.rowValue}>{props.voucher.references}</span></div>
          <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'purchase_date')}</span><span style={s.rowValue}>{dateLocale(props.voucher.created_at)}</span></div>
          {lastPayment && <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'last_purchase_date')}</span><span style={s.rowValue}>{dateLocale(lastPayment.created_at)}</span></div>}
          <div style={s.row}>
            <span style={s.rowLabel}>{translator(idiom, 'voucher', 'total_value')}</span>
            <span style={s.rowValue}>
              <NumberFormat value={Number(props.voucher.total) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} />
            </span>
          </div>
          <div style={s.row}>
            <span style={s.rowLabel}>{translator(idiom, 'voucher', 'paid_value')}</span>
            <span style={{ ...s.rowValue, color: '#22c55e' }}>
              <NumberFormat value={paidTotal} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} />
            </span>
          </div>
          {lastPayment && (
            <div style={s.row}>
              <span style={s.rowLabel}>{translator(idiom, 'voucher', 'pending_value')}</span>
              <span style={{ ...s.rowValue, color: '#f59e0b' }}>
                <NumberFormat value={Number(lastPayment.pending_total) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} />
              </span>
            </div>
          )}
          <div style={s.rowLast}>
            <span style={s.rowLabel}>{translator(idiom, 'voucher', 'payment_status')}</span>
            <span style={s.badge(payStatus.color)}>{payStatus.label}</span>
          </div>
        </div>

        {/* ── Passeios ── */}
        <p style={{ fontSize: '12px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '20px', marginBottom: '4px' }}>
          {translator(idiom, 'voucher', 'about_reservation')}
        </p>

        {props.voucher.status === 'canceled' && (
          <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: '8px', padding: '12px 16px', marginTop: '8px', color: '#b91c1c', fontSize: '13px' }}>
            Reserva cancelada por {props.voucher.logs?.name} em <Moment format="DD/MM/YYYY HH:mm" date={props.voucher.logs?.created_at} />
          </div>
        )}

        {props.voucher.reservations.map((v, idx) => (
          <div key={idx} style={s.tourCard}>
            <div style={s.tourName}>
              {v?.type === 'tour' ? v?.travel.name : v?.travel.region_name}
              {v?.type === 'transfer' ? ` (Transfer ${v?.transfer_type})` : ''}
            </div>
            <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'date')}</span><span style={s.rowValue}>{formatDate(v?.tour_date)}</span></div>
            <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'schedule')}</span><span style={s.rowValue}>{v?.times !== null ? getTimes(v) : formatHour(v?.flight_time) || '-'}</span></div>
            {v?.type === 'tour' && <>
              <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'adults')}</span><span style={s.rowValue}>{v?.adults_total}</span></div>
              <div style={s.row}>
                <span style={s.rowLabel}>{translator(idiom, 'voucher', 'value_by_adult')}</span>
                <span style={s.rowValue}><NumberFormat value={calcAdultsValue(v)} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
              </div>
              {Number(v?.kids_total) > 0 && <>
                <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'kids')}</span><span style={s.rowValue}>{v?.kids_total}</span></div>
                <div style={s.row}>
                  <span style={s.rowLabel}>{translator(idiom, 'voucher', 'value_by_kid')}</span>
                  <span style={s.rowValue}><NumberFormat value={calcKidsValue(v)} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
                </div>
              </>}
            </>}
            {v?.type === 'transfer' && <>
              <div style={s.row}><span style={s.rowLabel}>{translator(idiom, 'voucher', 'passagers')}</span><span style={s.rowValue}>{v?.adults_total}</span></div>
              <div style={s.row}>
                <span style={s.rowLabel}>{translator(idiom, 'voucher', 'value_by_passagers')}</span>
                <span style={s.rowValue}><NumberFormat value={Number(v?.adults_total_amount) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
              </div>
            </>}
            <div style={s.row}>
              <span style={s.rowLabel}>{translator(idiom, 'voucher', 'subtotal')}</span>
              <span style={s.rowValue}><NumberFormat value={Number(v?.price) + Number(v?.customer_discount) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
            </div>
            {Number(v?.customer_discount) > 0 && (
              <div style={s.row}>
                <span style={s.rowLabel}>{translator(idiom, 'voucher', 'discount')}</span>
                <span style={{ ...s.rowValue, color: '#22c55e' }}>
                  <NumberFormat value={Number(v?.customer_discount)} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={val => val} />
                  {' '}({((Number(v?.customer_discount) / (Number(v?.price) + Number(v?.customer_discount))) * 100).toFixed(2)}%)
                </span>
              </div>
            )}
            <div style={s.rowLast}>
              <span style={{ ...s.rowLabel, color: '#172B4D', fontSize: '14px' }}>{translator(idiom, 'voucher', 'total')}</span>
              <span style={{ ...s.rowValue, fontWeight: 700, color: '#172B4D', fontSize: '14px' }}><NumberFormat value={Number(v?.price) || 0} displayType="text" decimalSeparator="," decimalScale={2} fixedDecimalScale thousandSeparator="." isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={v => v} /></span>
            </div>
          </div>
        ))}

        {/* ── Termos ── */}
        {(props.voucher?.terms?.description || props.voucher?.terms?.description2 || props.voucher?.terms?.description3) && (
          <div style={s.termsWrap}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#172B4D', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px' }}>Termos e condições</div>
            {props.voucher?.terms?.description  && <div style={s.termsText} dangerouslySetInnerHTML={{ __html: cleanText(props.voucher.terms.description) }} />}
            {props.voucher?.terms?.description2 && <div style={{ ...s.termsText, fontWeight: 600, marginTop: '8px' }} dangerouslySetInnerHTML={{ __html: cleanText(props.voucher.terms.description2) }} />}
            {props.voucher?.terms?.description3 && <div style={{ ...s.termsText, marginTop: '8px' }} dangerouslySetInnerHTML={{ __html: cleanText(props.voucher.terms.description3) }} />}
          </div>
        )}

        {/* ── Assinatura ── */}
        <div style={{ ...s.signBox, borderColor: props.voucher?.signed_by_customer ? '#22c55e44' : '#e0e7ef' }}>
          {props.voucher?.signed_by_customer ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <span style={{ fontSize: '24px' }}>✅</span>
                <div>
                  <div style={{ fontWeight: 700, color: '#22c55e', fontSize: '15px' }}>Contrato assinado eletronicamente</div>
                  <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>{dateLocale(props.voucher?.signature_date)}</div>
                </div>
              </div>
              <div style={{ fontSize: '12px', color: '#555', lineHeight: '1.6' }}>
                <strong>{props.voucher?.customerData?.email}</strong> · {translator(idiom, 'voucher', 'document')} {props.voucher?.customerData?.document} · IP {props.voucher?.signature_ip}
              </div>
              {props.voucher?.signatures?.public_key && (
                <div>
                  <div style={{ fontSize: '10px', color: '#64748b', marginTop: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>HASH SHA256</div>
                  <div style={s.signHash}>{props.voucher.signatures.public_key}</div>
                </div>
              )}
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ fontSize: '13px', color: '#64748b' }}>Contrato aguardando assinatura do cliente.</div>
            </div>
          )}
        </div>

        {/* ── Rodapé ── */}
        <div style={s.footer}>
          <div style={{ fontWeight: 700, color: '#172B4D', marginBottom: '4px' }}>{props.voucher.company.name} — Adventure & Experience</div>
          <div>{translator(idiom, 'voucher', 'purchase_date')}: {dateLocale(props.voucher.created_at)} · ID: {props.voucher.id}</div>
        </div>

      </div>
    </div>;

  }
}

const VoucherLinkExit = props => {
  let { path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const componentRef = useRef()
  const { sale_id, token: tokenParam } = useParams();
  // Token pode vir na rota (:token) ou no query string (?access_token=...)
  const queryToken = new URLSearchParams(location.search).get('access_token');
  const token = tokenParam || queryToken;
  const [voucher, setVoucher] = useState({});
  const [loading, setLoading] = useState(true);
  const [sendingVoucher, setSendingVoucher] = useState(false);
  // Com token → rota pública do cliente (link enviado por e-mail)
  // Sem token → admin logado abrindo pelo painel (rota protegida por Bearer sanctum)
  let url = token
    ? `/customer/get_sale_voucher/${sale_id}?access_token=${token}`
    : `/sales/${sale_id}/voucher`;
  const [success, setSuccess] = useState(false);
  const sendVoucherUrl = `sales/${sale_id}/send_voucher`;
  const [openModal, setOpenModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [checked, setChecked] = useState(true);
  const [loadingSignature, setLoadingSignature] = useState(false);
  const [loadingCode, setLoadingCode] = useState(false);
  const [successCode, setSuccessCode] = useState(false);
  const [ip, setIP] = useState('');
  const [code, setCode] = useState('');
  const [codeConfirm, setCodeConfirm] = useState('');
  const [error, setError] = React.useState(false);

  const getVoucher = url => {
    return apiClient.httpInstance.get(url).then(response => {
      if (response.status === 200) {
        const d = response.data;
        const sortByDate = arr => (arr || []).slice().sort((a, b) => {
          const ta = a.tour_date ? new Date(a.tour_date + 'T00:00:00').getTime() : Infinity;
          const tb = b.tour_date ? new Date(b.tour_date + 'T00:00:00').getTime() : Infinity;
          return ta - tb;
        });
        if (d.reservations) d.reservations = sortByDate(d.reservations);
        if (d.budgets)      d.budgets      = sortByDate(d.budgets);
        setVoucher(d);
        setLoading(false);
      }
    }).catch(function (response) {
      // Não redireciona para login em rotas públicas de voucher
      setLoading(false);
    });
  }

  const sendVoucher = () => {
    setSendingVoucher(true);
    apiClient.httpInstance.post(sendVoucherUrl).then(response => {
      if (response.status === 200) {
        setSuccess(true);
        setSendingVoucher(false);
        setTimeout(() => {
          setSuccess(false);
        }, 2000);
      }
    });
  }

  const changeCodeConfirm = (value) => {
    setCodeConfirm(value)
  }

  const sendSignCode = (customer_id, customer_email) => {
    if (!customer_id || customer_id === 'undefined') {
      setError(true)
      return
    }
    setLoadingCode(true)
    setSuccessCode(false)
    setError(false)
    apiClient.httpInstance.post(`sales/${sale_id}/send_code_signature/${customer_id}`, { "email": customer_email }).then(response => {
      if (response.status === 200) {
        getVoucher(url);
        setSuccessCode(true)
      }
    }).catch(() => {
      setError(true)
    }).finally(() => {
      setLoadingCode(false)
    });
  }

  const confirmSignature = () => {
    setError(false)
    if (!codeConfirm) {
      setLoadingSignature(false)
      setError(true)
      return
    }
    setLoadingSignature(true)
    apiClient.httpInstance.post(`sales/${sale_id}/sale_signature`, {
      customer_ip: ip,
      customer_hash: codeConfirm
    }).then(response => {
      if (response.status === 200) {
        getVoucher(url).then(() => {
          setOpenModal(false)
          setSuccessModal(true)
        }).catch(() => {
          setOpenModal(false)
          setSuccessModal(true)
        });
      }
    }).catch(function (response) {
      setLoadingSignature(false)
      setError(true)
    });
    ;
  }

  //creating function to load ip address from the API
  const getIpClient = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    setIP(res.data.IPv4)
    /* apiClient.httpInstance.get('myIpSignature').then(response => {
      if (response.status === 200) {
          setIP(response.data.ip)
        }
    }); */
  }

  useEffect(() => {
    getVoucher(url);
    getIpClient();
  }, [url]);

  let theme = AdminConfig.themes[slugfy(props?.user?.data?.permission)] || AdminConfig.themes.logistica;

  return <Switch>
    <React.Fragment>
      <div className="flex flex-col admin">
        <Header theme={theme} />
        <div className="flex flex-row bg-lightgray">
          <Route path={`${path}`}>
            <div className="w-full mx-0 mb-20 pt-14" style={{ overflowX: 'hidden' }}>
              <>
                {!loading && <div className="px-4 w-full" style={{ boxSizing: 'border-box', maxWidth: '100%' }}>
                  <div className="flex items-center justify-between mt-2 text-2xl text-blue flex-wrap">
                    <div className="w-auto md:w-0">Voucher</div>
                    <div className="flex flex-wrap gap-2">
                      {voucher?.signed_by_customer ?
                        <Button
                          textcolor="#FFF"
                          padding="6px 15px"
                          width="200"
                        >
                          <Link color="inherit" to={`/sign/${sale_id}`} target='_blank'>
                            Exibir Assinatura
                          </Link>
                        </Button>
                        :
                        <Button
                          textcolor="#FFF"
                          padding="6px 15px"
                          width="200"
                          //disabled={voucher?.signed_by_customer ? true : false}
                          onClick={() => { setOpenModal(true); sendSignCode(voucher?.customerData?.id, voucher?.customerData?.email); } }
                        >
                          Assinar
                        </Button>
                      }
                      <ReactToPrint
                        trigger={() => <Button
                          textcolor="#FFF"
                          padding="6px 15px"
                          width="200"
                        >
                          Visualizar PDF
                        </Button>
                        }
                        content={() => componentRef.current}
                        pageStyle={`
                          @page { size: 10in 13.5in; margin: 10mm; }
                          @media print {
                            body { background: white !important; margin: 0; padding: 0; }
                            #desktop { display: block !important; }
                            .admin-header, header, nav { display: none !important; }
                          }
                        `}
                      />
                    </div>
                  </div>
                  <div className="my-4 d-flex">
                    {success && <Alert className="mt-5" severity="success" color="success">
                      Voucher enviado com sucesso
                    </Alert>}
                  </div>
                  {voucher && voucher.customerData && (
                    <Content
                      {...props}
                      voucher={voucher}
                      ref={componentRef}
                    />
                  )}
                </div>}
              </>
            </div>
          </Route>
        </div>
      </div>

      <Modal open={openModal} style={{ width: '90%', maxWidth: '450px' }}>
        <div className="justify-end text-center md:flex w-100">
          <Icon className="cursor-pointer" onClick={(ev) => setOpenModal(false)}>close</Icon>
        </div>
        {voucher?.signed_by_customer ?
          <><div className="flex mt-4">
            <p>Assinatura realizada em {dateLocale(voucher?.signature_date)}</p>
          </div>
            <div className="flex mt-4">
              <p style={{ wordBreak: 'break-word' }}>Email: {voucher?.customerData?.email}</p>
            </div>
            <div className="flex mt-4">
              <p>CPF: {voucher?.customerData?.document}</p>
            </div>
            <div className="flex my-4">
              <p>IP: {voucher?.signature_ip}</p>
            </div>
          </>
          :
          <form>
            {error && (<Alert className="mb-5" variant="filled" severity="error">
              Chave(s) inválida(s)!
            </Alert>)}
            {successCode && !error && (
              <Alert className="mb-3" variant="filled" severity="success">
                Código enviado para {voucher?.customerData?.email}
              </Alert>
            )}
            <div className="flex mt-4" style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
              <p>Dados do assinante:</p>
            </div>
            <div className="flex mt-2" style={{ fontSize: '0.9rem' }}>
              <p>Email: <strong>{voucher?.customerData?.email}</strong></p>
            </div>
            <div className="flex mt-1" style={{ fontSize: '0.9rem' }}>
              <p>CPF: <strong>{voucher?.customerData?.document}</strong></p>
            </div>
            <div className="flex mt-1" style={{ fontSize: '0.9rem' }}>
              <p>IP: {ip}</p>
            </div>
            <div className="flex mt-4 ml-2">
              <Checkbox
                className="p-0"
                value={checked}
                checked={checked}
                onChange={(ev) => setChecked(ev.target.checked, true)}
                color="dark"
              /><p onClick={() => setChecked(!checked)}>Declaro que estou de acordo</p>
            </div>
            {!ip && <div className="justify-center text-center mt-4 md:flex w -100">
              <Button
                textcolor="#fff"
                padding="10px 15px"
                margintop="0px"
                width="300px"
                disabled={!checked}
                onClick={(ev) => getIpClient()}>
                Atualizar IP
              </Button>
            </div>}
            <div className="mt-4" style={{ color: '#94a3b8', fontSize: '0.85rem' }}>
              <p>Um código foi enviado para seu e-mail. Insira-o abaixo para assinar:</p>
            </div>
            <div className="justify-center text-center mt-3 md:flex w -100">
              <TextField
                className="inputRounded"
                label="Insira a sua chave de assinatura"
                variant="outlined"
                type="text"
                value={codeConfirm}
                onChange={(ev) => changeCodeConfirm(ev.target.value)}
                required
              />
            </div>
            <div className="justify-center text-center mt-3 md:flex w-100">
              {loadingCode ?
                <Button
                  textcolor="#62DEC2"
                  variant="outlined"
                  bgColor="transparent"
                  margintop="0px"
                  width="300px"
                  style={{ border: '1px solid #62DEC2' }}
                  disabled
                >
                  <div className="flex items-center justify-center space-x-2">
                    <CircularProgress size={16} style={{ color: '#62DEC2' }} />
                    <span>Enviando...</span>
                  </div>
                </Button>
                :
                <Button
                  textcolor="#62DEC2"
                  bgColor="transparent"
                  margintop="0px"
                  width="300px"
                  style={{ border: '1px solid #62DEC2', borderRadius: '8px' }}
                  onClick={(ev) => {
                    sendSignCode(voucher?.customerData?.id, voucher?.customerData?.email)
                  }}
                >
                  <div className="flex items-center justify-center space-x-2">
                    <Icon style={{ fontSize: '16px' }}>email</Icon>
                    <span>Reenviar código por e-mail</span>
                  </div>
                </Button>
              }
            </div>
            <div className="justify-center text-center my-4 md:flex w-100">
              <Button
                textcolor="#fff"
                padding="10px 15px"
                margintop="0px"
                width="300px"
                disabled={!checked}
                onClick={(ev) => {
                  confirmSignature()
                }}
              >
                {loadingSignature ?
                  <div className="flex-1 text-center">
                    <CircularProgress size={20} />
                  </div>
                  :
                  'Confirmar assinatura'
                }
              </Button>
            </div>
          </form>
        }
      </Modal>

      <Modal open={successModal} style={{ width: '100%', maxWidth: '350px' }}>
        <div className="justify-end text-center md:flex w-100">
          <Icon className="cursor-pointer" onClick={(ev) => setSuccessModal(false)}>close</Icon>
        </div>
        <div className="flex mt-4">
          <p>Assinatura realizada em {dateLocale(voucher?.signature_date)}</p>
        </div>
        <div className="flex mt-4">
          <p>Email: {voucher?.customerData?.email}</p>
        </div>
        <div className="flex mt-4">
          <p>CPF: {voucher?.customerData?.document}</p>
        </div>
        <div className="flex my-4">
          <p>IP: {voucher?.signature_ip}</p>
        </div>
      </Modal>
    </React.Fragment>
  </Switch>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(VoucherLinkExit);
